export type LifestyleShot = {
  caption: string
  image: string
  alt: string
}

/**
 * Illustrative lifestyle scenes, not customer photographs, and deliberately
 * never tied to a named review.
 */
export const lifestyleShots: LifestyleShot[] = [
  {
    caption: 'Marble Maze',
    image: 'https://cdn.magicpatterns.com/uploads/uJcEp1SEtnUtizZxnfzAee/01-maze.png',
    alt: 'A girl at a kitchen table holding a finished cardboard marble maze made from a box lid and coloured straws, with the project page open on a tablet beside her',
  },
  {
    caption: 'Desk Organizer',
    image: 'https://cdn.magicpatterns.com/uploads/g8hw5dtCGd27u1T3dyAB5z/02-organizer.png',
    alt: 'A boy placing coloured pencils into a desk organizer he built from cardboard tubes, with the step-by-step page open on a tablet on the table',
  },
  {
    caption: 'Cardboard Car',
    image: 'https://cdn.magicpatterns.com/uploads/hGX7DaARerZfazddLPYLS1/03-car.png',
    alt: 'A girl on a living-room floor pushing a cardboard car with bottle-cap wheels, with the build instructions open on a tablet nearby',
  },
  {
    caption: 'Truss Road Bridge',
    image: 'https://cdn.magicpatterns.com/uploads/3rDGmFBnSWdQKjKk33jsG2/04-bridge.png',
    alt: 'A boy and his father testing a straw-and-cardboard truss bridge at the kitchen table, with the numbered project steps open on a tablet',
  },
  {
    caption: 'Building the maze',
    image: 'https://cdn.magicpatterns.com/uploads/61eP2AMqdG4nQdoFncDo7V/05-overhead.png',
    alt: 'An overhead view of a child and an adult taping coloured straws inside a cardboard tray to shape a marble route, with the project page open on a tablet and a ruler and pencil on the table',
  },
  {
    caption: 'Make it your own',
    image: 'https://cdn.magicpatterns.com/uploads/qTbfqLe6BTu6tj9nQikwTK/06-side.png',
    alt: 'A girl decorating the cardboard tubes of her desk organizer with hearts and rainbows while an adult tears tape beside her, with the build page open on a tablet',
  },
]
